import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Client-side redirect to another site, for in-app navigation to a path listed
 * in data/redirects.json. Direct hits are served by the static redirect page
 * that scripts/prerender.mjs writes for the same path.
 */
export function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <Helmet>
      <title>Redirecting…</title>
      <meta name="robots" content="noindex" />
      <link rel="canonical" href={to} />
    </Helmet>
  );
}
